module.exports = __webpack_public_path__ + "web/img/verify7.fac281d8.jpg";